import toast from "react-hot-toast";
import i18n from "../i18n";

export const copyToClipboard = async (
    text: string,
    successMessage?: string,
    errorMessage?: string
): Promise<boolean> => {
    const sMsg = successMessage || i18n.t("copySuccess");
    const eMsg = errorMessage || i18n.t("setting.error.copyFailed");

    if (!text) {
        toast.error(i18n.t("setting.error.noTextToCopy"));
        return false;
    }

    if (navigator.clipboard) {
        try {
            await navigator.clipboard.writeText(text);
            toast.success(sMsg);
            return true;
        } catch {
            // Fallback if clipboard fails
        }
    }

    // Legacy fallback
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.cssText = "position:fixed;top:-1000px;left:-1000px;opacity:0";

    document.body.appendChild(textarea);
    textarea.select();

    const success = document.execCommand('copy');
    document.body.removeChild(textarea);

    if (success) {
        toast.success(sMsg);
    } else {
        toast.error(eMsg);
    }

    return success;
};